import React from "react";
import { Button, Card } from "react-bootstrap";
import { useHistory } from "react-router";

import * as TimelineStyle from "./timeline.module.css";
import { projectList } from "../data";

export default function Projects() {
    const history = useHistory();
    
    return (
        <div className="container pt-3 pt-md-4">
        <Card className={`shadow-sm ${TimelineStyle.cta_card}`}>
          <Card.Header className="border-0 d-flex align-items-center justify-content-between">
            <h4 className="text-white mb-0 font-weight-bold">Projects</h4>
            <Button
              className=""
              variant="none"
              size="sm"
              onClick={() => history.push("projects")}
            >
              <span className="text-primary font-weight-bold">See all</span>
            </Button>
          </Card.Header>
          <Card.Body>
            <div className="d-flex" style={{ overflowX: "scroll" }}>
              {projectList.map((project, key) => (
                <div className="col-md-4 pl-0" key={key}>
                  <Card
                    className={`h-100 ${TimelineStyle.services_cards}`}
                    onClick={() => history.push(`project/${project.slug}`)}
                    style={{ cursor: "pointer" }}
                    title={`Project: ${project.name}`}
                  >
                    <div
                      style={{
                        backgroundImage: `url(${project.image})`,
                        height: 150,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    />
                    <Card.Body className="py-2 px-3">
                      {/* <p className="small text-uppercase text-danger mb-1">
                        Project
                      </p> */}
                      <p className="font-weight-bold text-white mb-1">
                        {project.name}
                      </p>
                      <p className="font-weight-bold small mb-0 text-warning">
                        {project.date}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      </div>
    )
}
